export const OptionType = {
  REGULAR: 0,
  DANGER: 1,
};

export const OptionSize = {
  SMALL: 0,
  MEDIUM: 1,
};
